import { render } from "./DragHandle.vue?vue&type=template&id=801d6c0a"
import script from "./DragHandle.vue?vue&type=script&lang=js"
export * from "./DragHandle.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__